import React from "react";
import { Link } from "react-router-dom";

export interface OrderTypeSelectorProps {
    onSelect?: (type: string) => void;
    onBack?: () => void;
}

const OrderTypeSelector: React.FC<OrderTypeSelectorProps> = ({ onSelect, onBack }) => {

    return (
        <React.Fragment>
            <div className="header-area" id="headerArea">
                <div
                    className="container h-100 d-flex text-center align-items-center justify-content-between rtl-flex-d-row-r">
                    <div className="back-button me-2">
                        <button
                            className="btn btn-link p-0 border-0"
                            type="button"
                            onClick={onBack}
                        >
                            <i className="mdi mdi-arrow-left"></i>
                        </button>
                    </div>

                    <div className="page-heading">
                        <h6 className="mb-0">Bạn muốn dùng món ở đâu?</h6>
                    </div>

                    <div className="suha-navbar-toggler border-unset ms-2"></div>
                </div>
            </div>
            <div className="page-content-wrapper">
                <div className="container">
                    <div className="checkout-wrapper-area py-3">
                        <div className="choose-payment-method">
                            <div className="row g-2 justify-content-center rtl-flex-d-row-r">
                                <div className="col-6 col-md-5">
                                    <div className="single-payment-method single-payment-method-custom">
                                        <Link
                                            className="bank"
                                            to="/#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (onSelect) onSelect('dine_in');
                                            }}
                                        >
                                            <i className="mdi mdi-storefront-outline"></i>
                                            <h6>Tại quán</h6>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-6 col-md-5">
                                    <div className="single-payment-method single-payment-method-custom">
                                        <Link
                                            className="bank"
                                            to="/#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (onSelect) onSelect('takeaway');
                                            }}
                                        >
                                            <i className="mdi mdi-food-takeout-box-outline"></i>
                                            <h6>Mang đi</h6>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default OrderTypeSelector;
